import { Helmet } from "react-helmet-async";

const BlogsSchema = ({ data }) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": data.name,
    "description": data.description,
    "url": data.url,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
    </Helmet>
  );
};

export default BlogsSchema;
